/** Componente raíz: restaura sesión y menú, muestra spinner mientras cargan, y monta ConfigProvider (locale es-ES y tema), Toaster, ErrorBoundary y router. */
import "./App.css";
import { ConfigProvider } from "antd";
import esES from "antd/locale/es_ES";
import { useEffect } from "react";
import { Toaster } from "sileo";
import AppRouter from "./components/router/AppRouter";
import ErrorBoundary from "./components/errorBoundary/ErrorBoundary";
import Spinner from "./components/spinner/Spinner";
import WithApiCheck from "./hoc/withApiCheck";
import { useAuthStore } from "./stores/authStore";
import { useUIStore } from "./stores/uiStore";
import { useAuth } from "./hooks/useAuth";
import { useMenu } from "./hooks/useMenu";

const App = () => {
  const loadingApp = useAuthStore((s) => s.loadingApp);
  const loggedUserInnerwork = useAuthStore((s) => s.loggedUserInnerwork);
  const menuReady = useUIStore((s) => s.menuReady);
  const theme = useUIStore((s) => s.theme);
  const darkMode = useUIStore((s) => s.darkMode);

  useAuth();
  useMenu();

  useEffect(() => {
    document.body.classList.toggle("dark-mode", darkMode);
  }, [darkMode]);

  if (loadingApp) {
    return (
      <div className="loading-container">
        <Spinner />
      </div>
    );
  }

  const hasSession = Object.keys(loggedUserInnerwork).length > 0;
  if (hasSession && !menuReady) {
    return (
      <div className="loading-container">
        <Spinner />
      </div>
    );
  }

  return (
    <ConfigProvider locale={esES} theme={theme}>
      <Toaster
        position="bottom-left"
        theme={darkMode ? "light" : "dark"}
        offset={16}
        options={{ roundness: 4, fill: darkMode ? "#1a1a1a" : "#ffffff" }}
      />
      <ErrorBoundary>
        <AppRouter />
      </ErrorBoundary>
    </ConfigProvider>
  );
};

export default WithApiCheck(App, true);
